import { Itemset } from "../store/viewmodels/ItemsetViewModel"
import { Item } from "../store/viewmodels/ItemViewModel"
import { Task } from "../store/viewmodels/TaskViewModel"
import { Logo } from "../store/viewmodels/LogoViewModel";
import { ItemFile } from "../store/viewmodels/ItemFileViewModel";
import { AnswerFileResult } from "../store/viewmodels/AnswerFileViewModel";
import { FrontPageFile } from "../store/viewmodels/FrontPageFileViewModel";
import HoverVideoPlayer from "./HoverVideoPlayer/HoverVideoPlayer";


const emptyItemset: Itemset = {
    id: Math.min(),
    name: "",
    type: "",
    settings: {},
    items: [],
    logos: [] as Logo[],
    index: NaN,
    ready_to_publish: false
}

const emptyItem: Item = {
    id: Math.min(),
    name: "",
    type: "",
    settings: {},
    files: [],
    content: "",
    child_items: [],
    correct: "",
    index: NaN
}

export function mediaURLMod(originalURL: string) {
    const modIndex: number = originalURL.indexOf('media')
    const modURL = originalURL.substr(0, modIndex) + 'api/' + originalURL.substr(modIndex, originalURL.length)
    return modURL
}

export function getLogos(originalURL: string) {
    const isLocal: boolean = window.location.href.includes('localhost') ? true : false
    if (isLocal) { return originalURL }
    else {
        const modIndex: number = originalURL.indexOf('media')
        const modURL = originalURL.substr(0, modIndex) + 'api/' + originalURL.substr(modIndex, originalURL.length)
        return modURL
    }
}

export function getItemset(task: Task, itemsetId: string): Itemset {
    let itemset: Itemset | undefined = task.itemsets.find(itemset => itemsetId === itemset.id.toString())
    return itemset ? itemset : emptyItemset;
}

export function getItem(itemset: Itemset, itemId: string): Item {
    let item: Item | undefined = itemset.items.find(item => itemId === item.id.toString())
    return item ? item : emptyItem;
}

export function sortItemsInItemset(itemset: Itemset) {
    let sortedItemset: Itemset = {} as Itemset
    sortedItemset.id = itemset.id
    sortedItemset.name = itemset.name
    sortedItemset.type = itemset.type
    sortedItemset.settings = itemset.settings
    let sortedItems = [...itemset.items].sort(function (a, b) { return a.index - b.index })
    sortedItemset.items = sortedItems
    return sortedItemset
}

// Used for getting all item files under a single item
export function getElementsByFiles(item: Item) {

    let errorElements: JSX.Element[] = [];
    let itemFiles: JSX.Element[] = [];
    let fileCount: number = item.files.length;
    if (fileCount === 0) {
        errorElements.push(<>NO ITEM FILE</>)
        return errorElements;
    }

    for (let i = 0; i < fileCount; i++) {
        let pathSplitted: string[] = item.files[i]?.file.split('.');
        let fileExtension = pathSplitted[pathSplitted.length - 1];

        if (!fileExtension) {
            errorElements.push(<>NO ITEM FILE</>)
            return errorElements;
        }

        let modURL: string = item.files[i].file
        let isLocal: boolean = window.location.href.includes('localhost') ? true : false
        if (!isLocal) {
            modURL = mediaURLMod(item.files[i].file)
        }

        switch (fileExtension) {
            case 'jpg':
            case 'png':
            case 'jpeg':
                itemFiles.push(<img key={item.files[i].file + "_" + item.id} src={modURL} alt="Failed to load" />)
                break
            case 'webm':
                itemFiles.push(<HoverVideoPlayer key={fileExtension + modURL + item.id} videoSrc={modURL} srcType="video/webm" preload="auto" />)
                break;
            case 'mp4':
                itemFiles.push(<HoverVideoPlayer key={fileExtension + modURL + item.id} videoSrc={modURL} srcType="video/mp4" preload="auto" />)
                break;

            default:
                errorElements.push(<>ITEM FILE TYPE NOT SUPPORTED </>)
                return errorElements;
        }
    }
    return itemFiles;
}

// Used for getting a single file from an item
export function getFileElement(file: AnswerFileResult | FrontPageFile | ItemFile): JSX.Element {
    if (file === null || file === undefined) return <>NO FILE</>;
    let pathSplitted: string[] = file.file.split('.');
    let fileExtension = pathSplitted[pathSplitted.length - 1];
    if (!fileExtension) return <>NO FILE</>;

    let modURL: string = file.file
    let isLocal: boolean = window.location.href.includes('localhost') ? true : false
    if (!isLocal) {
        modURL = mediaURLMod(file.file)
    }

    let itemId = file.id ? file.id : -1;

    switch (fileExtension) {
        case 'jpg':
        case 'png':
        case 'jpeg':
            return <img key={fileExtension + modURL + itemId} src={modURL} alt="Failed to load" />;
        case 'webm':
            return <HoverVideoPlayer key={fileExtension + modURL + itemId} videoSrc={modURL} srcType="video/webm" preload="auto" />;
        case 'mp4':
            return (
                <HoverVideoPlayer key={fileExtension + modURL + itemId} videoSrc={modURL} srcType="video/mp4" preload="auto" />
            );

        default:
            return <>FILE TYPE NOT SUPPORTED</>;
    }
}